import { render, staticRenderFns } from "./DetalleKitModal.vue?vue&type=template&id=33ca1748"
import script from "./DetalleKitModal.vue?vue&type=script&lang=js"
export * from "./DetalleKitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports